import { render, staticRenderFns } from "./DinventoryIndex.vue?vue&type=template&id=4224c249&scoped=true"
import script from "./DinventoryIndex.vue?vue&type=script&lang=js"
export * from "./DinventoryIndex.vue?vue&type=script&lang=js"
import style0 from "./DinventoryIndex.vue?vue&type=style&index=0&id=4224c249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4224c249",
  null
  
)

export default component.exports